import { Injectable } from '@angular/core';

import { PayRoll, PayRollBatch } from '@models';
import { environment } from 'src/environment/environment';
import { CrudService } from '../crud/crud.service';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class PayRollService extends CrudService<PayRoll> {
  constructor(http: HttpService) {
    super('pay-roll', http);
  }

  async uploadPayRollBatch(file: File): Promise<string> {
    const endpoint = `${environment.apiUrl}/pay-roll/batch/upload`;
    const response = await this.http.postWithFile<PayRollBatch>(
      endpoint,
      {},
      file
    );
    if (!response.success) throw new Error(response.message);
    return response.message;
  }

  async processPayRollBatch(payRollBatchId: string): Promise<string> {
    const endpoint = `${environment.apiUrl}/pay-roll/batch/process/${payRollBatchId}`;
    const response = await this.http.post<PayRollBatch>(endpoint, {});
    if (!response.success) throw new Error(response.message);
    return response.message;
  }

  async getPayRollBatches(): Promise<PayRollBatch[]> {
    const endpoint = `${environment.apiUrl}/pay-roll/batch/all`;
    const response = await this.http.get<PayRollBatch[]>(endpoint);
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  async getPayRollBatchById(batchId: string): Promise<PayRollBatch> {
    const endpoint = `${environment.apiUrl}/pay-roll/batch/${batchId}`;
    const response = await this.http.get<PayRollBatch>(endpoint);
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  async getPayRollById(payRollId: string): Promise<PayRoll> {
    const endpoint = `${environment.apiUrl}/pay-roll/${payRollId}`;
    const response = await this.http.get<PayRoll>(endpoint);
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  // override methods which are not available for this service

  override get(): Promise<PayRoll[]> {
    throw new Error('Method not available.');
  }
  override update(data: Partial<PayRoll>): Promise<PayRoll> {
    throw new Error('Method not available.');
  }
  override delete(id: string): Promise<string> {
    throw new Error('Method not available.');
  }
}
